<template>
  <div class="main">
    <h3 class="heading">Project Timeline</h3>

    <div class="container">
        <ul>
            <li>
                <h3 class="title">รับเอกสารนำส่งเงินทุนวิจัย</h3>
                <p>เจ้าหน้าที่ได้รับเอกสารเข้าหน่วยงานแล้ว อยู่ในขั้นตอนกำลังตรวจสอบความถูกต้องของเอกสาร</p>
                <a href="#">Read More ></a>
                <span class="circle"></span>
                <span class="date">{{row.step1}}</span>
            </li>
            <li>
                <h3 class="title">จัดทำบันทึกนำส่งเงินทุนวิจัย</h3>
                <p>เอกสารได้รับการตรวจสอบเรียบร้อยแล้ว และได้ส่งบันทึกออกไปยัง ม.มหิดล เรียบร้อยแล้ว</p>
                <a href="#">Read More ></a>
                <span class="circle"></span>
                <span class="date">{{row.step2}}</span>
            </li>
            <li>
                <h3 class="title">รอเอกสารจาก ม.มหิดล และ งานคลังคณะฯ</h3>
                <p>ม.มหิดและงานคลังคณะฯ กำลังตรวจสอบเอกสารเพื่อออกใบจองงบ</p>
                <a href="#">Read More ></a>
                <span class="circle"></span>
                <span class="date">{{row.step3}}</span>
            </li>
            <li>
                <h3 class="title">จัดทำบันทึกเบิกเงินทุนวิจัย</h3>
                <p>เจ้าหน้าที่รับเอกสารจาก ม.มหิดล และ งานคลังคณะฯ และจัดทำบันทึกเบิกเงินทุนวิจัยแล้ว</p>
                <a href="#">Read More ></a>
                <span class="circle"></span>
                <span class="date">{{row.step4}}</span>
            </li>
            <li>
                <h3 class="title">เงินเข้าบัญชีโครงการวิจัยแล้ว</h3>
                <p>เงินสนับสนุนโครงการวิจัย ได้โอนเข้าบัญชีโครงการวิจัยแล้ว ท่านสามารถอัพเดตสมุดบัญชีเพื่อตรวจสอบยอดเงินปัจจุบัน</p>
                <a href="#">Read More ></a>
                <span class="circle"></span>
                <span class="date">{{row.step5}}</span>
            </li>
            
        </ul>
        
    </div>
    <div>
        <br>
   
        <h3 class="footer">FINISH</h3>
    </div>
    
  </div>
</template>

<script>
	export default {
		name: "Timeline",
		props: ["row"],
    data() {
      return {
        test: true
      };
    },
	}
	
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&family=Rancho&family=Water+Brush&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Thai:wght@500&family=Kodchasan:wght@500&family=Noto+Sans+Thai+Looped&family=Sarabun:wght@300&display=swap');
  *{
      padding: 0;
      margin: 0;
      box-sizing: border-box;
  }
  .main{
    width: 100%;
    height: auto;
    background-color: #ebe8e9;
    font-family: poppins;
    padding: 50px 0;
    display: grid;
    place-items: center;
    max-width: 1600px;
    width: 91vw;
    margin-right: auto;
    margin-left: auto;
  }
  .main .heading{
      font-size: 40px;
      font-weight: 1000;
      color: #000000;
      position: relative;
      margin-bottom: 80px;
  }
  .main .footer{
      font-size: 40px;
      font-weight: 1000;
      color: #155ebd;
      position: relative;
      margin-bottom: 80px;
  }
  .heading::after{
      content: " ";
      position: absolute;
      width: 100%;
      height: 4px;
      left: 50%;
      bottom: -5px;
      background-image: linear-gradient(to right, #af94d2, #1496b0);
      transform: translateX(-50%);
  }

  /* Container Css Start  */

  .container{
      width: 70%;
      height: auto;
      position: relative;
      
  }
  .container ul::after{
      position: absolute;
      content: '';
      width: 2px;
      height: 100%;
      background-image: linear-gradient(to right, #ebe8e9, #21bdce);
  }
  .container ul{
      list-style: none;
  }
  .container ul li{
      width: 50%;
      height: auto;
      padding: 15px 20px;
      background-color: #f3f3f3;
      margin-bottom: 30px;
      border-radius: 10px;
      box-shadow: 4px 4px 25px rgba(2, 64, 21, 0.518);
      position: relative;
      z-index: 99;
  }
  .container ul li:nth-child(odd){
      float: left;
      clear: right;
      transform: translateX(-30px);
  }
  .container ul li:nth-child(odd) .date{
      right: 20px;
  }
  .container ul li:nth-child(even){
      float: right;
      clear: left;
      transform: translateX(30px);
  }
  .container ul li:nth-child(5){
      margin-bottom: 0;
  }
  .container ul li .title{
      font-size: 20px;
      font-weight: 1000;
      color: rgb(10, 12, 167);
  }
  ul li p{
      font-size: 15px;
      color: #444;
      margin: 7px 0;
      line-height: 23px;
  }
  ul li a{
      font-size: 15px;
      color: rgb(179, 179, 179);
      text-decoration: none;
  }
  ul li .date{
      position: absolute;
      top: -45px;
      width: 135px;
      height: 35px;
      border-radius: 100px;
      color: #ffffff;
      background-image: linear-gradient(to right, #8ee3ff, #155ebd);
      display: grid;
      place-items: center;
      font-size: 16px;
      font-weight: 1000;
  }
    ul li .current_date{
      position: absolute;
      top: -45px;
      width: 135px;
      height: 35px;
      border-radius: 20px;
      color: #ffffff;
      background-image: linear-gradient(to right, #8ee3ff, #155ebd);
      display: grid;
      place-items: center;
      font-size: 16px;
      font-weight: 1000;
  }
      ul li .current1_date{
      position: absolute;
      top: -45px;
      width: 135px;
      height: 35px;
      border-radius: 20px;
      color: #ffffff;
      background-image: linear-gradient(to right, #8ee3ff, #155ebd);
      display: grid;
      place-items: center;
      font-size: 16px;
      font-weight: 1000;
  }
  .container ul li .circle{
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: rgba(119, 214, 231, 0.401);
      position: absolute;
      top: 0;
  }
  .container ul li .circle::after{
      content: '';
      position: absolute;
      width: 15px;
      height: 15px;
      background-color: rgb(11, 101, 198);
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
  }
  .container ul li:nth-child(odd) .circle{
      right: -30px;
      transform: translate(50%, -50%);
  }
  .container ul li:nth-child(even) .circle{
      left: -30px;
      transform: translate(-50%, -50%);
  }

  /*  Media Query Started  */

  @media screen and (max-width:1224px){
      .container{
          width: 85%;
      }
  }

  @media screen and (max-width:993px){
      .container{
          width: 80%;
          transform: translateX(15px);
      }
      .container ul::after{
          left: -30px;
      }
      .container ul li{
          width: 100%;
          float: none;
          clear: none;
          margin-bottom: 80px;
      }
      .container ul li:nth-child(odd){
          text-align: left;
          transform: translateX(0);
      }
      .container ul li:nth-child(odd) .date{
          left: 20px;
      }
      .container ul li:nth-child(odd) .circle{
          left: -30px;
          transform: translate(-50%, -50%);
      }
      .container ul li:nth-child(even){
          transform: translateX(0);
      }

  }

  .ul ,li , h3 {

    font-family: 'IBM Plex Sans Thai', sans-serif;
    font-family: 'Kodchasan', sans-serif;
    font-family: 'Noto Sans Thai Looped', sans-serif;
    font-family: 'Sarabun', sans-serif;
  

  }
 

</style>